import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Home, BookOpen, Video, User, BarChart3, Calendar, Settings } from 'lucide-react';
import { useAuth } from '@/contexts/auth-context';

export function MobileNav() {
  const location = useLocation();
  const pathname = location.pathname;
  const { profile } = useAuth();

  const getNavItems = () => {
    if (profile?.role === 'admin') {
      return [
        { href: '/dashboard', label: 'Dashboard', icon: Home },
        { href: '/dashboard/courses', label: 'Corsi', icon: BookOpen },
        { href: '/dashboard/users', label: 'Utenti', icon: User },
        { href: '/dashboard/settings', label: 'Settings', icon: Settings },
      ];
    }
    if (profile?.role === 'docente') {
      return [
        { href: '/dashboard', label: 'Dashboard', icon: Home },
        { href: '/dashboard/my-courses', label: 'Corsi', icon: BookOpen },
        { href: '/dashboard/live', label: 'Live', icon: Video },
        { href: '/dashboard/profile', label: 'Profilo', icon: User },
      ];
    }
    return [
      { href: '/dashboard', label: 'Home', icon: Home },
      { href: '/dashboard/calendar', label: 'Calendario', icon: Calendar },
      { href: '/dashboard/my-learning', label: 'I miei', icon: Video },
      { href: '/dashboard/profile', label: 'Profilo', icon: User },
    ];
  };

  const navItems = getNavItems();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = pathname === item.href || pathname?.startsWith(item.href + '/');
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex flex-col items-center justify-center flex-1 h-full space-y-1 transition-colors',
                isActive
                  ? 'text-blue-600'
                  : 'text-gray-600 hover:text-blue-600'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
